import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type SubscriptionResponse = ResponseType<any>;

function SubscriptionQuery() {
  return useQuery<
    AxiosResponseAndError<SubscriptionResponse>["response"],
    AxiosResponseAndError<SubscriptionResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.paymentsubscription],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.paymentSubscription),
    enabled: true,
  });
}

export default SubscriptionQuery;
